/**
 * Battery percentage clamp.
 *
 * Scale normalisation (0.0–1.0 fraction vs 0–100) is done ONCE, in the
 * backend telemetry handler (manager.py), which is the single source of
 * truth. This helper therefore only clamps into [0, 100].
 *
 * v6.3.32: previously this rescaled a second time (`raw <= 1.5 → *100`),
 * so a genuine 1.2% reading — already 0–100 from the backend — rendered as
 * 100%. Every value below 1.5% displayed as a full pack.
 *
 * Returns a number in [0, 100], or null when the input isn't a number.
 */
export const normalizeBatteryPercent = (raw: unknown): number | null => {
  if (raw == null || typeof raw !== 'number' || !isFinite(raw)) return null;
  // v6.3.32 FIX: the backend (manager.py telemetry handler) is the single
  // authority for scale normalisation — it already emits canonical 0–100.
  // This function used to rescale AGAIN (`raw <= 1.5 → *100`), so a genuine
  // 1.2% battery arriving from the backend rendered as 100% — every reading
  // below 1.5% displayed as a full pack. Frontend now only clamps.
  return Math.max(0, Math.min(100, raw));
};

/** Format as integer percent with '%' suffix, or '--' when unknown. */
export const formatBatteryPercent = (raw: unknown): string => {
  const v = normalizeBatteryPercent(raw);
  return v == null ? '--' : `${Math.round(v)}%`;
};
